export function initTOC() {
    const list = document.querySelector('[data-toc]');
    if (!list) return;

    const content = document.querySelector('.gh-content');
    if (!content) return;

    const headings = Array.from(content.querySelectorAll('h2, h3'));
    if (!headings.length) {
        list.style.display = 'none';
        return;
    }

    headings.forEach((h, i) => {
        if (!h.id) {
            h.id = h.textContent.trim().toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .slice(0, 60) || `section-${i + 1}`;
        }
    });

    list.innerHTML = headings.map((h, i) => {
        const num = String(i + 1).padStart(2, '0');
        return `<li><a href="#${h.id}" data-toc-link><span style="color: var(--color--mute);">${num} · </span>${h.textContent}</a></li>`;
    }).join('');

    const links = Array.from(list.querySelectorAll('a'));

    const setActive = (id) => {
        links.forEach((link) => {
            const target = link.getAttribute('href').slice(1);
            link.classList.toggle('is-active', target === id);
        });
    };

    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActive(entry.target.id);
                    }
                });
            },
            { rootMargin: '-30% 0% -60% 0%', threshold: 0 },
        );
        headings.forEach((h) => io.observe(h));
    }

    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const id = link.getAttribute('href').slice(1);
            const target = document.getElementById(id);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.replaceState(null, '', `#${id}`);
            }
        });
    });
}
